import * as React from "react";
import { styled } from "@mui/system";
import MUIStepLabel from "@mui/material/StepLabel";
import { StepLabelProps } from "@mui/material/StepLabel";

export const StepLabel: (props: StepLabelProps) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, StepLabelProps>((props, ref) => (
    <MUIStepLabel ref={ref} {...props} />
  )),
  {
    name: "StepLabel",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiStepLabel-root .MuiStepLabel-iconContainer > svg": {
    borderRadius: "50%",
    fontSize: 32
  },
  "&.MuiStepLabel-root.Mui-disabled .MuiStepLabel-iconContainer > svg": {
    borderRadius: "50%",
    height: 29,
    width: 29,
    border: "2px solid #C9D9E8",
    color: theme.palette.primary.surfaceDefault + " !important",
    background: "#C9D9E8 !important",
    ":hover": {
      cursor: "not-allowed",
      pointerEvents: "all !important"
    },
    "& .MuiStepIcon-text": {
      fill: "#C9D9E8"
    }
  },

  "&.MuiStepLabel-root .MuiSvgIcon-root.MuiStepIcon-root.Mui-completed": {
    borderRadius: "50%",
    color: theme.palette.primary.surfaceDefault + " !important",
    height: 29,
    width: 29,
    border: "2px solid " + theme.palette.primary.primary,
    background: theme.palette.primary.primary,
    ":hover": {
      cursor: "pointer"
    }
  },
  "&.MuiStepLabel-root .MuiStepConnector-line": {
    borderRadius: "50%",
    borderColor: theme.palette.primary.primaryBackgroundHover + " !important",
    borderTopWidth:
      "2px solid " +
      theme.palette.primary.primaryBackgroundHover +
      " !important"
  },

  "&.MuiStepLabel-root .MuiStepConnector-line.Mui-completed": {
    borderColor: theme.palette.primary.primary + " !important",
    background: theme.palette.primary.primary + " !important"
  },
  "&.MuiStepLabel-root.MuiStepLabel-vertical .MuiStepLabel-labelContainer": {
    textAlign: "left"
  },
  "&.MuiStepLabel-root .MuiStepLabel-labelContainer": {
    textAlign: "center",
    color: theme.palette.primary.textTitleColor
  },
  "&.MuiStepLabel-root .MuiStepLabel-label": {
    color: theme.palette.primary.textTitleColor
  }
}));
